module.exports = __webpack_public_path__ + "img/tpc-web-7.8b3b380e.jpg";